import axios from '@/utils/api'

const state = {
}

const getters = {
}

const actions = {
  async getConfiguracaoMonitoramento ({ commit }, numeroProcesso) {
    const data = await axios({
      method: 'GET',
      url: `statusAmbiental?numeroProcesso=${numeroProcesso}`
    })
    return data
  },
  async getCruzamentoMonitoramento ({ commit }, numeroProcesso) {
    const data = await axios({
      method: 'GET',
      url: `statusAmbiental/cruzamento?numeroProcesso=${numeroProcesso}`
    })
    return data
  }
}

const mutations = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/analise/monitoramentoAmbiental.js